var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBarChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50781 11C1.50781 10.4477 1.95553 10 2.50781 10H4.50781C5.0601 10 5.50781 10.4477 5.50781 11V14C5.50781 14.5523 5.0601 15 4.50781 15H2.50781C1.95553 15 1.50781 14.5523 1.50781 14V11Z",
    fill: "#4559A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50781 7C6.50781 6.44772 6.95553 6 7.50781 6H9.50781C10.0601 6 10.5078 6.44772 10.5078 7V14C10.5078 14.5523 10.0601 15 9.50781 15H7.50781C6.95553 15 6.50781 14.5523 6.50781 14V7Z",
    fill: "#4559A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5078 2C11.5078 1.44772 11.9555 1 12.5078 1H14.5078C15.0601 1 15.5078 1.44772 15.5078 2V14C15.5078 14.5523 15.0601 15 14.5078 15H12.5078C11.9555 15 11.5078 14.5523 11.5078 14V2Z",
    fill: "#4559A7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/bar-chart.ac081dec481c8b0610b91f38b875a562.svg";
export { ForwardRef as ReactComponent };